/* global axios */
import ApiClient from './ApiClient';

class PipelineItemsAPI extends ApiClient {
  constructor() {
    super('pipeline_items', { accountScoped: true });
  }

  reorder(stageId, orderedIds) {
    return axios.post(`${this.url}/reorder`, {
      stage_id: stageId,
      ordered_ids: orderedIds,
    });
  }

  getByContact(contactId) {
    return axios.get(this.url, { params: { contact_id: contactId } });
  }

  getByConversation(conversationId) {
    return axios.get(this.url, { params: { conversation_id: conversationId } });
  }
}

export default new PipelineItemsAPI();
